<template>
    <v-expansion-panel>
        <template>
            <v-expansion-panel-header class="mt-2">
                Cuentas por pagar a proveedores
                <template v-slot:actions>
                    <v-btn class="mr-5" @click.native.stop="reload()" icon small>
                        <v-icon color="primary">mdi-reload</v-icon>
                    </v-btn>
                    <v-btn @click="$store.dispatch('deleteWindowByUuid', { uuid: win.uuid })" icon small>
                        <v-icon color="error">mdi-close</v-icon>
                    </v-btn>
                </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-tabs v-model="tab" dark background-color="primary" icons-and-text>
                    <v-tabs-slider color="red"></v-tabs-slider>
                    <v-tab href="#tab-1">
                        Cuentas
                        <v-icon>mdi-account-cash-outline</v-icon>
                    </v-tab>
                    <!-- <v-tab href="#tab-2">
                        Resumen de Cuentas
                        <v-icon>mdi-chart-bar</v-icon>
                    </v-tab> -->
                    <v-tab href="#tab-3">
                        Estado de Cuentas
                        <v-icon>mdi-account-check</v-icon>
                    </v-tab>
                    <!-- <v-tab href="#tab-4">
                        Clientes
                        <v-icon>mdi-account-multiple</v-icon>
                    </v-tab> -->
                </v-tabs>

                <v-tabs-items v-model="tab" touchless>
                    <v-tab-item value="tab-1">
                        <v-card flat class="pa-1">
                            <v-card-text class="white" style="border-radius: 10px;">
                                        <AccountsPayableList :key="key" :win="win"></AccountsPayableList>             
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <!-- <v-tab-item value="tab-2">
                        <v-card flat style="padding: 16px;" class="py-1 px-1">
                            <v-card-text class="white" style="border-radius: 10px;">
                                <div>tab-2</div>        
                            </v-card-text>
                        </v-card>
                    </v-tab-item> -->
                    <v-tab-item value="tab-3">
                        <v-card flat class="pa-1">
                            <v-card-text class="white" style="border-radius: 10px;">
                                <CustomersAccountsPayable :key="key" />
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <!-- <v-tab-item value="tab-4">
                        <v-card flat class="pa-5 position-relative">
                            <v-card-text>
                                <div>tab-4</div>
                            </v-card-text>
                        </v-card>
                    </v-tab-item> -->
                </v-tabs-items>
            </v-expansion-panel-content>
        </template>
        
    </v-expansion-panel>
</template>

<script>
    
    import AccountsPayableList from '../tabs/AccountsPayableList.vue';
    import CustomersAccountsPayable from '../tabs/CustomersAccountsPayable.vue';

    export default {
        name: "AccountsPayable",
        components: {
            AccountsPayableList,
            CustomersAccountsPayable,
        },
        props: ['win'],
        data() {
            return {
                panel: 0,
                tab: null,
                key: 0,
                
                
            }
        },
       
       
        methods: {
            reload() {
                this.key++;
                setTimeout(() => {
                window.scrollTo(0, this.$store.getters.getScrollTop)
               
                },300);
            },
        },

    }
</script>

<style scoped>

</style>